module.exports = __webpack_public_path__ + "static/media/Illus-Delivery_2.2f18b6dc.png";